var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        /* Shared for the gallery and reviews; neither construction nor subscription sends a request. */
        (function () {
            var stores = new Map();

            var ReviewPhotos = function () {
                function ReviewPhotos(url) {
                    _classCallCheck(this, ReviewPhotos);

                    this.url = url;
                    this.promise = null;
                    this.items = null;
                }

                _createClass(ReviewPhotos, [{
                    key: "load",
                    value: function load() {
                        var _this = this;

                        if (!this.promise) {
                            this.promise = fetch(this.url, { headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' } }).then(function (response) {
                                if (!response.ok) throw new Error('Hotel photos request failed');
                                return response.json();
                            }).then(function (data) {
                                _this.items = data.items;
                                return _this.items;
                            }).catch(function (error) {
                                _this.promise = null;
                                throw error;
                            });
                        }
                        return this.promise;
                    }
                }, {
                    key: "forReview",
                    value: function forReview(id) {
                        var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'our';

                        return (this.items || []).filter(function (photo) {
                            return String(photo.reviewId) === String(id) && photo.source === source;
                        });
                    }
                }]);

                return ReviewPhotos;
            }();

            window.HotelReviewPhotos = {
                get: function get(hotelId, url) {
                    var key = String(hotelId);
                    if (!stores.has(key)) stores.set(key, new ReviewPhotos(url));
                    return stores.get(key);
                }
            };
        })();

        window.HotelReviewPhotoView = {
            createItem: function createItem(photo, globalIndex) {
                var extraCount = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

                var item = document.createElement('div');
                item.className = 'photo-item';
                item.dataset.reviewId = photo.reviewId;
                item.dataset.photoIndex = globalIndex;
                var loader = document.createElement('span');
                loader.className = 'photo-item-loader';
                loader.setAttribute('aria-hidden', 'true');
                item.appendChild(loader);
                var image = document.createElement('img');
                var finishLoading = function finishLoading() {
                    return loader.remove();
                };
                image.addEventListener('load', finishLoading, { once: true });
                image.addEventListener('error', finishLoading, { once: true });
                image.className = 'review-photo lazy-img-observe';
                image.dataset.src = photo.url;
                image.alt = '';
                item.appendChild(image);
                if (extraCount) {
                    item.classList.add('more', 'blurred');
                    var count = document.createElement('span');
                    count.className = 'photo-count-label';
                    count.textContent = '+' + extraCount;
                    item.appendChild(count);
                }
                return item;
            }
        };
    }, {}] }, {}, [1]);